<template>
  <v-footer dark class="app app-bar">
    <v-row dense>
      <v-col cols="12" md="2"></v-col>
      <v-col cols="12" sm="12" md="8">
        <v-btn
          href="https://edupluscampus.com/"
          target="_blank"
          text
          class="no-text-transform footer-btn"
          block
          ><span class="company-name">
            © {{ new Date().getFullYear() }} Powered By EduplusCampus
            <!-- Vishwakarma Global Education Services Pvt Ltd. -->
          </span>
    <!-- <span style="opacity:0.5">Ver:{{ ver }}</span> -->
        </v-btn>
        <!-- <v-icon>mdi-open-in-new</v-icon> -->
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
import { version } from '../../package.json'
export default {
  data() {
    return {
      ver: ""
    };
  },
   created() {
    this.ver = version
  },
};
</script>
<style scoped>
.app {
  background: #025464; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #025464,
    #025464,
    #025464
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #025464,
    #025464,
    #025464
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
@media (max-width: 920px) {
  body {
    overflow-x: hidden;
    width: 100%;
  }

  .app-bar {
    /* height: 70px !important; */
    width: 100% !important;
  }
  .footer-btn {
    text-transform: none;
    font-size: 12px !important;
    display: block;
    word-wrap: break-word;
  }
  .company-name {
    /* color: red; */
    white-space: normal;
  }
}
.footer-btn {
  text-transform: none;
  font-size: 12px;
}
</style>